import { defineMessages } from 'react-intl'

import { intl } from 'common/components/l10n/IntlGlobalProvider'

export const getStartDatePlaceholderMsg = () => {
  const messages = defineMessages({
    message: {
      id: 'DateRangePickerWrapper.start',
      description: 'Label on a date picker',
      defaultMessage: 'Departure date',
    },
  })
  return intl.formatMessage(messages.message)
}

export const getEndDatePlaceholderMsg = () => {
  const messages = defineMessages({
    message: {
      id: 'DateRangePickerWrapper.end',
      description: 'Label on a date picker',
      defaultMessage: 'Return date',
    },
  })
  return intl.formatMessage(messages.message)
}
